import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';

const TermsOfServicePage = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
            Terms of Service
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </Typography>
          
          <Typography paragraph>
            Please read these Terms of Service ("Terms") carefully before using the roamzap website and services.
          </Typography>
          
          <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mt: 4 }}>
            1. Acceptance of Terms
          </Typography>
          
          <Typography paragraph>
            By accessing or using our services, you agree to be bound by these Terms. If you do not agree to all the terms 
            and conditions of this agreement, you may not access or use our services.
          </Typography>
          
          <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mt: 4 }}>
            2. Description of Service
          </Typography>
          
          <Typography paragraph>
            Roamzap provides a platform for users to plan and organize travel itineraries, discover destinations, 
            and access travel-related content. Our services may change from time to time without prior notice.
          </Typography>
          
          <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mt: 4 }}>
            3. User Accounts
          </Typography>
          
          <Typography paragraph>
            When you create an account with us, you must provide accurate, complete, and up-to-date information. 
            You are solely responsible for maintaining the confidentiality of your account and password and for restricting 
            access to your computer or device.
          </Typography>
          
          <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mt: 4 }}>
            4. Content and Information
          </Typography>
          
          <Typography paragraph>
            Our platform may contain travel information, recommendations, and itineraries generated by artificial intelligence 
            or based on other sources. While we strive to provide helpful and accurate information, we do not guarantee 
            the accuracy, completeness, or reliability of any content on our platform.
          </Typography>
          
          <Typography paragraph>
            You acknowledge and agree that:
          </Typography>
          
          <ul>
            <li>
              <Typography paragraph>
                All travel decisions ultimately rest with you, and you should verify any critical information before making travel arrangements.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                We are not responsible for any errors, omissions, or inaccuracies in the content provided.
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                We are not liable for any loss or damage that may result from your reliance on information provided through our services.
              </Typography>
            </li>
          </ul>
          
          <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mt: 4 }}>
            5. Third-Party Services and Links
          </Typography>
          
          <Typography paragraph>
            Our services may include links to third-party websites, services, or content that are not owned or controlled by Roamzap. 
            We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party 
            websites or services.
          </Typography>
          
          <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mt: 4 }}>
            6. Limitation of Liability
          </Typography>
          
          <Typography paragraph>
            To the maximum extent permitted by applicable law, in no event shall roamzap, its affiliates, agents, directors, 
            employees, suppliers, or licensors be liable for any indirect, punitive, incidental, special, consequential, or exemplary 
            damages, including without limitation damages for loss of profits, goodwill, use, data, or other intangible losses, 
            that result from the use of, or inability to use, this service.
          </Typography>
          
          <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mt: 4 }}>
            7. Changes to These Terms
          </Typography>
          
          <Typography paragraph>
            We reserve the right to modify or replace these Terms at any time at our sole discretion. It is your responsibility 
            to review these Terms periodically for changes. Your continued use of our services following the posting of any changes 
            to these Terms constitutes acceptance of those changes.
          </Typography>
          
          <Divider sx={{ my: 4 }} />
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfServicePage; 